import createSelector from "../../utils/reselect";

const programsStateData = (state) => {
  const { programs } = state;
  return programs || {};
};

export const program = createSelector(programsStateData, (programs) =>
  programs.get("program")
);

export const programs = createSelector(programsStateData, (programs) =>
  programs.get("programs")
);

export const programsLoading = createSelector(programsStateData, (programs) =>
  programs.get("programsLoading")
);

export const overviewLoader = createSelector(programsStateData, (programs) =>
  programs.get("overviewLoader")
);

export const programLoading = createSelector(programsStateData, (programs) =>
  programs.get("programLoading")
);

export const programsPagination = createSelector(
  programsStateData,
  (programs) => programs.get("programsPagination")
);

export const programBudgetSummary = createSelector(programsStateData, (programs) =>
  programs.get("programBudgetSummary")
);
export const programProgressSummary = createSelector(programsStateData, (programs) =>
  programs.get("programProgressSummary")
);
export const programBudgetSummaryLoading = createSelector(programsStateData, (programs) =>
  programs.get("programBudgetSummaryLoading")
);
export const programProgressSummaryLoading = createSelector(programsStateData, (programs) =>
  programs.get("programProgressSummaryLoading")
);

// ///////////////////////// HEALTH STATUS /////////////////////////////

export const progressTracker = createSelector(programsStateData, (programs) =>
  programs.get("progressTracker")
);


export const programReport = createSelector(programsStateData, (programs) =>
  programs.get("programReport")
);

export const programReportLoading = createSelector(programsStateData, (programs) =>
  programs.get("programReportLoading")
);